import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CraSelectedService {
  private craSelected: any;

  // Save the CRA element
  setCRASelected(cra: any): void {
    this.craSelected = cra;
  }

  // Retrieve the CRA element
  getCRASelected(): any {
    return this.craSelected;
  }

  hasCRASelected(): boolean {
    return !!this.craSelected;
  }
}
